import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { CollapsibleTrigger } from "@/components/ui/collapsible";
import { RotateCcw, ChevronDown, ChevronUp, Filter } from "lucide-react";
import FilterBadge from "./FilterBadge";
import { cn } from "@/lib/utils";

interface FilterHeaderProps {
  isOpen: boolean;
  activeFilterCount: number;
  selectedEmiMonth?: string | null;
  onEmiMonthChange?: (month: string) => void;
  emiMonthOptions?: string[];
  onClearAllFilters: () => void;
  hasAnyFilters?: boolean;
  children?: ReactNode;
}

const FilterHeader = ({
  isOpen,
  activeFilterCount,
  onClearAllFilters,
  hasAnyFilters = false,
  children,
}: FilterHeaderProps) => {
  return (
    <div className={cn("px-3 py-2.5", isOpen && "border-b border-gray-200")}>
      <div className="flex items-center gap-3">
        <CollapsibleTrigger asChild>
          <Button
            variant="outline"
            className="h-10 shrink-0 gap-2 rounded-lg border-gray-200 bg-white px-3 font-medium text-gray-900 shadow-none hover:bg-gray-50"
          >
            <Filter className="h-4 w-4" />
            <span>Filters</span>
            {isOpen ? (
              <ChevronUp className="h-4 w-4 text-gray-500" />
            ) : (
              <ChevronDown className="h-4 w-4 text-gray-500" />
            )}
            <FilterBadge count={activeFilterCount} />
          </Button>
        </CollapsibleTrigger>

        {children ? <div className="min-w-0 flex-1">{children}</div> : <div className="flex-1" />}

        <Button
          variant="ghost"
          onClick={onClearAllFilters}
          className="h-10 shrink-0 gap-2 px-2 text-gray-600 hover:bg-transparent hover:text-gray-900"
          disabled={!hasAnyFilters}
        >
          <RotateCcw className="h-4 w-4" />
          Clear All
        </Button>
      </div>
    </div>
  );
};

export default FilterHeader;
